__turbopack_context__.v({
  "copy": "VStAlW_copy",
  "cta": "VStAlW_cta",
  "icon": "VStAlW_icon",
  "inner": "VStAlW_inner",
  "item": "VStAlW_item",
  "list": "VStAlW_list",
  "root": "VStAlW_root",
  "title": "VStAlW_title",
});
